import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopResponse } from '@/repositories/generated';

const response: ShopResponse[] = [
  {
    id: '00000001',
    name: 'モック店舗1',
  },
  {
    id: '00000002',
    name: 'モック店舗2',
  },
  {
    id: '00000003',
    name: 'モック店舗3',
  },
];

export const autocompleteShop = http.get(
  createMockEndpoint('/autocomplete/shop'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
